import { render, staticRenderFns } from "./ProvinceCityAreaView.vue?vue&type=template&id=15708bbe&scoped=true&"
import script from "./ProvinceCityAreaView.vue?vue&type=script&lang=ts&"
export * from "./ProvinceCityAreaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15708bbe",
  null
  
)

export default component.exports